export default "__VITE_ASSET__C2LWo_xT__"